export const NOT_FOUND_ERROR = 'not_found'

export const FACEBOOK_SIGNED_REQUEST_COOKIE_NAME = 'fbsr_'

export const SSO_TYPE_FACEBOOK = 'Facebook'

export const SSO_TYPE_GOOGLE = 'Google'

export const SSO_TYPE_APPLE = 'Apple'

export const POP_UP_CLOSED_BY_USER = 'popup_closed_by_user'
export const NEW_SESSION_FROM_USER = 'user_trigger_new_signin_flow'
export const APPLE_SSO_CLOSED_BY_USER = 'Apple SSO Failed'
